export default __webpack_public_path__ + "static/media/Untitled-1.40cf2820.png";